<template>
    <div class="wizard-steps flex">
        <span class="line absolute"></span>
        <div
            v-for="(step, index) in steps"
            :key="index"
            class="step"
            :id="`step-${index + 1}`"
            :class="{
                activated: stepIsActivated(index),
                active: stepIsActive(step),
                disabled: stepIsDisabled(index)
            }"
            @click="next(step.name)"
        >
            <div class="inner-circle"></div>
            <div class="bullet">{{ index + 1 }}</div>
            <img src="/img/done-white-18dp.svg" alt="" />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { GETTERS, MUTATIONS } from "../../store/wizard/types";
import next from '../../mixins/next';

export default {
    mixins: [next],

    computed: {
        ...mapGetters({
            steps: GETTERS.GET_STEPS,
            currentStep: GETTERS.GET_CURRENT_STEP_INDEX,
            maxIndex: GETTERS.GET_MAX_STEP_INDEX
        })
    },
    watch: {
        $route:{
            immediate:true,
            handler(to,from) {
                this.setCurrentStep(to);
                this.setMaxIndex(this.currentStep);
            }
        }
    },
    methods: {
        ...mapMutations({
            setCurrentStep: MUTATIONS.SET_CURRENT_STEP_INDEX,
            setMaxIndex: MUTATIONS.SET_MAX_STEP_INDEX
        }),
        stepIsDisabled(stepIndex) {
            return stepIndex > this.maxIndex;
        },
        stepIsActivated(stepIndex) {
            return stepIndex < this.currentStep;
        },
        stepIsActive(step) {
            return this.$route.name === step.name;
        }
    }
};
</script>

<style lang="scss">
.wizard-steps {
    height: 100px;
}
</style>
